"use client";

/**
 * 選択欄。候補から 1 つを選ぶ
 *
 * 空の選択肢（placeholder）は、ふつうは「おまかせ」のような選べる候補として常に並ぶ。
 * required を付けると、空の選択肢は選ぶ前の案内になり、候補を選んだら並びから消える。
 */
export default function SelectField({
  id,
  label,
  value,
  onChange,
  options,
  placeholder,
  note,
  disabled,
  required,
}: {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  options: string[];
  placeholder?: string;
  note?: string;
  disabled?: boolean;
  required?: boolean;
}) {
  const showEmpty = !required || value === "";

  return (
    <div className="field">
      <label className="field-label" htmlFor={id}>
        {label}
      </label>
      <select
        id={id}
        className="field-input field-select"
        value={value}
        disabled={disabled}
        onChange={(event) => onChange(event.target.value)}
      >
        {showEmpty ? (
          <option value="" disabled={required}>
            {placeholder ?? "選んでください"}
          </option>
        ) : null}
        {options.map((option) => (
          <option value={option} key={option}>
            {option}
          </option>
        ))}
      </select>
      {note ? <p className="field-note">{note}</p> : null}
    </div>
  );
}
